"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ActionColumn_1 = require("../../Column/components/ActionColumn");
const react_1 = __importDefault(require("react"));
exports.ActionComponent = ({ actions, child, onAction, col, colIndex, row, rowIndex, className, }) => {
    return (react_1.default.createElement(ActionColumn_1.ActionColumn, { className: className, actions: (actions === null || actions === void 0 ? void 0 : actions[child.action]) || [], row: row, colIndex: colIndex, rowIndex: rowIndex, column: col, label: child.label, tooltip: child.tooltip, actionDispatcher: onAction }));
};
//# sourceMappingURL=ActionComponent.js.map